import __request__ from "routing/request";
export function types() {
  return __request__("GET", "/system/inputs/types", null, {}, {
    "Accept": ["application/json"]
  });
}
export function all() {
  return __request__("GET", "/system/inputs/types/all", null, {}, {
    "Accept": ["application/json"]
  });
}
export function info(inputType) {
  return __request__("GET", `/system/inputs/types/${inputType}`, null, {}, {
    "Accept": ["application/json"]
  });
}
